import axios from "axios";

export default async function customLogin(payload) {

    const baseURL = "https://alfa-api-dev.azurewebsites.net/api/customlogin";

    let allResponse = {};
    console.log("payload", payload);

    try {

        const response = await axios.post(
            baseURL,
            payload,
            {
                headers: {
                    "x-functions-key": "ZIzf54MbzrtjmtQhmTB86bLJ6sI2WSOPMXkvkpsoTONYAzFur0m02w==",
                }
            }
        );

        allResponse = response;

        return Promise.resolve(allResponse);

    } catch (error) {

        console.log("error!!!", error)
        return Promise.reject(error)

    }
}
